module.exports = __webpack_public_path__ + "static/image-90efe12b33029873a13407e624973bc1.jpg";